<router-outlet />
<!--
  Single toast host for the whole app; fed by NotifyService (core/notify).
  Rendered eagerly (not @defer): toasts raised during bootstrap — e.g. the
  transfer-token guard on a hard load — were lost before the host mounted.
-->
<hlm-toaster
  position="top-right"
  richColors
  [duration]="4000"
  closeButton
  [visibleToasts]="4"
  [theme]="theme.resolved()"
/>
